import { render, staticRenderFns } from "./RankedItem.vue?vue&type=template&id=6501d0de&scoped=true"
import script from "./RankedItem.vue?vue&type=script&lang=js"
export * from "./RankedItem.vue?vue&type=script&lang=js"
import style0 from "./RankedItem.vue?vue&type=style&index=0&id=6501d0de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6501d0de",
  null
  
)

export default component.exports